var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-head-wrapper" }, [
    !_vm.account.isSeparateKey
      ? _c("div", { staticClass: "head__item" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: _vm.iconList.headAcc }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "head-right" }, [
            _c("div", { staticClass: "head-title" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("accountName")))]),
              _vm._v(" "),
              _c("span", {
                staticClass: "edit __pointer",
                on: { click: _vm.startRename }
              })
            ]),
            _vm._v(" "),
            !_vm.isShowNameInput
              ? _c(
                  "div",
                  { staticClass: "name", on: { click: _vm.startRename } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.account.isSeparateKey
                            ? _vm.$t("assets.vb.accountName")
                            : _vm.account.name
                        ) +
                        "\n            "
                    )
                  ]
                )
              : _c("form", { attrs: { autocomplete: "off" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editName,
                        expression: "editName"
                      }
                    ],
                    ref: "nameInput",
                    attrs: {
                      type: "text",
                      placeholder: _vm.account.name,
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.editName },
                    on: {
                      blur: _vm.rename,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.editName = $event.target.value
                      }
                    }
                  })
                ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "head__item" }, [
      _c("img", { staticClass: "icon", attrs: { src: _vm.iconList.headAcc } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "head-right" },
        [
          _c("SwitchAddr", { attrs: { isShowAddr: false } }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "address-content" },
            [
              _c("copy", { ref: "copyDom", staticClass: "copy-tips" }),
              _vm._v(" "),
              _c("span", { staticClass: "addr_item" }, [
                _vm._v(_vm._s(_vm.activeAddr))
              ]),
              _vm._v(" "),
              _c(
                "QrcodePopup",
                { attrs: { qrcodeString: _vm.addressQrcode } },
                [
                  _c("span", {
                    staticClass: "address-content__operate qrcode click-able"
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "address-content__operate copy click-able",
                on: { click: _vm.copy }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isHardware && _vm.isLogin
            ? _c("span", { staticClass: "address-content__verify" }, [
                _c("span", { on: { click: _vm.verifyHwAddress } }, [
                  _vm._v(_vm._s(_vm.$t("assets.ledger.verifyAddress")))
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "worth head__item" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: _vm.iconList.headAsset }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "assets" },
        [
          _c("AssetSwitch", {
            staticClass: "asset-switch",
            model: {
              value: _vm.assetsType,
              callback: function($$v) {
                _vm.assetsType = $$v
              },
              expression: "assetsType"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "asset__btc" }, [
            _vm._v(_vm._s(_vm.assetBtc) + " BTC")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "asset__cash" }, [
            _vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.asset))
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "head__item chart" },
      [
        _c("Pie", {
          staticClass: "pie-chart",
          attrs: {
            pieData: _vm.pieData.data,
            labelGen: _vm.labelGen,
            title: _vm.$t("tokenCard.assetSpread")
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }